
import { defineComponent } from 'vue';
import TpxCheckboxGroup from '../../atoms/form/checkbox-group.vue';
import './filter-group.scss';

/**
  * Filter group
  * 
  * @example
  * <code>import TpxFilterGroup from '@manifesto-tech/tpximpact-design-system/components/molecules/filter/filter-group.vue'</code>
  */
export default defineComponent({
  name: 'TpxFilterGroup',
  extends: TpxCheckboxGroup,

  components: {
    TpxCheckboxGroup,
  },

  methods: {
    toggle() {
      this.$refs.content.classList.toggle('is-open');
      this.$refs.icon.classList.toggle('is-open');
      const theBackdrop = this.$parent.$parent.$refs.formBackdrop;

      if (theBackdrop != null) {
        theBackdrop.classList.add("is-open");
      }

    }
  }
});
